import { createFileRoute } from "@tanstack/react-router";
import FastTrdPage from "@/pages/learn/FastTrdPage";
import { pageFastTrd } from "@/pages/learn/learnDataFastTrd";
export const Route = createFileRoute(
  "/learn/fast-treatment-resistant-depression-options",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Faster Treatment for Treatment-Resistant Depression | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "Faster treatment options for treatment-resistant depression: medication, therapy, TMS, SAINT®, Spravato, ketamine. Why fast does not mean best for everyone..",
        },
        {
          property: "og:title",
          content:
            "Faster Treatment for Treatment-Resistant Depression | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "Faster treatment options for treatment-resistant depression: medication, therapy, TMS, SAINT®, Spravato, ketamine. Why fast does not mean best for everyone..",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/learn/fast-treatment-resistant-depression-options",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/fast-treatment-resistant-depression-options",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(pageFastTrd.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FastTrdPage />;
}
